import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBanned = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 23" {...props}>
    <path
      d="M.643 13.678C.603 12.666.58 12.03.57 11.77c-.058-1.44.795-2.505 2.561-3.198 2.65-1.04 10.053-2.493 20.103.206 2.364.454 3.368 1.943 3.16 3.272-.138.886-.262 1.744-.372 2.573-.24 1.035-1.005 1.435-2.293 1.2-1.933-.352-1.288-.265-2.837-.582-1.549-.317-1.397-.448-2.1-2.175-.701-1.726-.278-2.158-2.645-2.254-1.578-.064-3.666-.082-6.265-.054-.918-.045-1.483.5-1.695 1.636-.317 1.703-.707 2.08-2.517 2.43a29.29 29.29 0 0 1-3.464.472C1.204 15.23.683 14.69.643 13.678zM2.236.607l21.557 21.24"
      fill="none"
      stroke="#FFF"
    />
  </svg>
);
const Memo = memo(SvgBanned);
export default Memo;
